import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoEvaluacion: [],
  },

  getters: {
    getTipoEvaluacion: (state) => state.tipoEvaluacion,
  },

  mutations: {
    SET_TIPO_EVALUACION(state, tipoEvaluacion) {
      state.tipoEvaluacion = tipoEvaluacion;
    },
  },

  actions: {
    async fetchTipoEvaluacion({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/cattipoEvaluacion')
        .then((response) => {
          commit('SET_TIPO_EVALUACION', response.data.data);
        });
    },
  },
};
